module.exports = __webpack_public_path__ + "img/Eye_Icon_lighter.c581ee25.svg";